var _effectorFileName = "/builds/gmini/front-ui-kit/src/FormulaInput/insertMention.ts";
import { Transforms } from 'slate';
export const insertMention = (editor, property) => {
  // TODO сделать тип для Mention
  const mention = {
    type: 'mention',
    property,
    children: [{
      text: ''
    }]
  };
  const space = {
    text: ' '
  };
  Transforms.insertNodes(editor, [mention, space]);
  Transforms.move(editor, {
    distance: 2,
    unit: 'offset'
  }); // Снимаем выделение со смещением каретки на вставленный пробел
};
export const insertOperator = (editor, operator) => {
  Transforms.insertNodes(editor, [{
    text: `${operator.name} `
  }]);
  Transforms.move(editor, {
    distance: 1,
    unit: 'offset'
  });
};